const MAX_STAR_RATING = 6;

/**
 * Takes in tailpipe co2 emissions in g/km and returns the VESR rating
 * See: https://www.vesr.gov.au/how-vesr-works
 */
const getVehicleEmissionStarRating = (tailpipeCo2: number) => {
  const halfStarDeductions = Math.floor(tailpipeCo2 / 25) + Math.min(tailpipeCo2 % 25, 1);
  const starDeductions = halfStarDeductions / 2;
  return Math.max(MAX_STAR_RATING - starDeductions, 0.5);
};

export default getVehicleEmissionStarRating;
